import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditSession = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Session'
      fields={fields}
      apiPath={`admin/sessions/${props.params.sessionId}`}
      successRedirectPath='/write-now/sessions'
      buildMenuItems={menuItems}
    />
  )
}

export default EditSession
